import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import i18n from 'src/i18n'
import { DropdownActions } from '../dropdownActions'
import { CommunityListMenuEventNames } from '../../communityListMenu.types'
import { useCommunityPermissions } from '../../hooks'
import { CommunityGroupHeaderActionsProps } from './communityGroupHeaderActions.types'

const CommunityGroupHeaderActions = ({ group }: CommunityGroupHeaderActionsProps) => {
  const { emitEvent } = useCustomEvent()
  const {
    canCreateCommunityGroup,
    canEditCommunityGroup,
    canDeleteCommunityGroup,
    canCreateCommunity
  } = useCommunityPermissions()

  const shouldRenderActions =
    canCreateCommunityGroup ||
    canEditCommunityGroup ||
    canDeleteCommunityGroup ||
    canCreateCommunity

  if (!shouldRenderActions) {
    return null
  }

  return (
    <div className="_d-flex _align-items-center">
      <DropdownActions
        triggerIcon={faPlus}
        items={[
          {
            label: i18n.t('sidebar_menu.community_group.actions.create'),
            visible: canCreateCommunityGroup,
            callback: () => emitEvent(CommunityListMenuEventNames.CREATE_COMMUNITY_GROUP)
          },
          {
            label: i18n.t('sidebar_menu.community_group.actions.create_community'),
            visible: canCreateCommunity,
            callback: () =>
              emitEvent(CommunityListMenuEventNames.CREATE_COMMUNITY, { groupId: group.id })
          }
        ]}
      />

      <DropdownActions
        items={[
          {
            label: i18n.t('sidebar_menu.community_group.actions.edit'),
            visible: canEditCommunityGroup,
            callback: () => emitEvent(CommunityListMenuEventNames.EDIT_COMMUNITY_GROUP, { group })
          },
          {
            label: i18n.t('sidebar_menu.community_group.actions.delete'),
            visible: canDeleteCommunityGroup,
            callback: () => emitEvent(CommunityListMenuEventNames.DELETE_COMMUNITY_GROUP, { group })
          }
        ]}
      />
    </div>
  )
}

export default CommunityGroupHeaderActions
